<div class="container" [ngClass]="{ 'light-mode': !isDarkMode(), 'dark-mode': isDarkMode() }">

  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> CII

  </p>

  <!-- <button class="refresh-btn"
          matTooltip="Refresh"
          matTooltipPosition="below"
          (click)="refreshPageData()">
    <mat-icon class="refresh-icon">refresh</mat-icon>
  </button> -->




  <div class="filter-header" style="margin-top: 25px;">
    <form [formGroup]="myreportForm" class="filter-flex-container">

      <!-- Client Name -->
      <mat-form-field *ngIf="username === 'Meraki - Operations'" appearance="outline" floatLabel="always"
        class="compact-field">
        <mat-label>Client Name</mat-label>
        <mat-select formControlName="client" placeholder="Select Client">
          <mat-option value="">All Clients</mat-option>
          <mat-option *ngFor="let c of clientList" [value]="c">
            {{ c }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vessel Name -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Vessel Name</mat-label>
        <mat-select formControlName="vesselname" placeholder="Select Vessels" multiple>
          <mat-option *ngFor="let ship of vesselNameSuggestions" [value]="ship.ship_name">
            {{ ship.ship_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vessel IMO -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Vessel I.M.O</mat-label>
        <input matInput formControlName="vesselIMO" placeholder="Enter IMO">
      </mat-form-field>


      <button mat-flat-button color="warn" class="fetch-btn clear-btn" (click)="clearClick()">
        Clear
      </button>

      <button mat-flat-button color="primary" class="fetch-btn" (click)="filterClick()">
        Apply Filter
      </button>

    </form>
  </div>

  <!-- TABLE -->
  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table" id="style-4" matSort>

      <thead class="sticky-header">
        <tr>
          <th rowspan="2">S.No</th>
          <th rowspan="2" class="th-text-center" *ngIf="username === 'Meraki - Operations'">BDN</th>
          <th rowspan="2" class="th-text-center" *ngIf="username === 'Meraki - Operations'">Upload</th>
          <th rowspan="2" class="th-text-center">Ship View</th>

          <th rowspan="2" mat-sort-header="ship_name" class="left">Vessel Name</th>
          <th rowspan="2" mat-sort-header="imo_number" class="left">IMO No</th>
          <th rowspan="2" mat-sort-header="type_of_vessel" class="left">Vessel Type</th>
          <th rowspan="2" mat-sort-header="vessel_ice_class">Ice Class</th>
          <th rowspan="2" mat-sort-header="loadline_summer_deadweight_metric_tonnes">DWT</th>

          <th colspan="5" class="th-text-center">Fuel Consumed (MT)</th>

          <th rowspan="2" mat-sort-header="distance_travelled">Distance (NM)</th>
          <th rowspan="2" mat-sort-header="required_cii">Required CII</th>
          <th rowspan="2" mat-sort-header="referenced_cii">Reference CII</th>
          <th rowspan="2" mat-sort-header="attained_cii">Attained CII <br> (YTD)</th>
          <th rowspan="2" mat-sort-header="rating">Rating</th>

          <th rowspan="2" class="th-text-center">Allowance</th>
          <th rowspan="2" class="th-text-center"  *ngIf="subusername !== 'demo'">Generate Report</th>
        </tr>

        <tr class="sub-header">
          <!-- <th [attr.colspan]="username === 'Meraki - Operations' ? 9 : 7"></th> -->
          <th>HFO</th>
          <th>LFO</th>
          <th>MDO</th>
          <th>LNG</th>
          <th>Biofuel</th>
          <!-- <th colspan="6"></th> -->
        </tr>
      </thead>


      <tbody>
        <!-- Skeleton Loading -->
        <ng-container *ngIf="isLoading; else dataRows">
          <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="skeleton-row">
            <td><div class="skeleton-cell skeleton" style="width: 24px; height: 18px;"></div></td>
            <!-- BDN -->
            <td class="th-text-center" *ngIf="username === 'Meraki - Operations'">
              <div class="skeleton-cell skeleton" style="width: 24px; height: 24px; border-radius: 50%; margin: 0 auto;"></div>
            </td>
            <!-- Upload BDN/LOP -->
            <td class="th-text-center" *ngIf="username === 'Meraki - Operations'">
              <div class="skeleton-cell skeleton" style="width: 24px; height: 24px; border-radius: 50%; margin: 0 auto;"></div>
            </td>
            <!-- Details Button -->
            <td class="th-text-center">
              <div class="skeleton-cell skeleton" style="width: 24px; height: 24px; border-radius: 50%; margin: 0 auto;"></div>
            </td>
            <!-- Ship Name -->
            <td><div class="skeleton-cell skeleton" style="width: 120px; height: 18px;"></div></td>
            <!-- IMO -->
            <td><div class="skeleton-cell skeleton" style="width: 75px; height: 18px;"></div></td>
            <!-- Type -->
            <td><div class="skeleton-cell skeleton" style="width: 85px; height: 18px;"></div></td>
            <!-- Ice Class -->
            <td><div class="skeleton-cell skeleton" style="width: 45px; height: 18px;"></div></td>
            <!-- DWT -->
            <td><div class="skeleton-cell skeleton" style="width: 65px; height: 18px;"></div></td>
            <!-- HFO -->
            <td><div class="skeleton-cell skeleton" style="width: 50px; height: 18px;"></div></td>
            <!-- LFO -->
            <td><div class="skeleton-cell skeleton" style="width: 50px; height: 18px;"></div></td>
            <!-- MDO -->
            <td><div class="skeleton-cell skeleton" style="width: 50px; height: 18px;"></div></td>
            <!-- LNG -->
            <td><div class="skeleton-cell skeleton" style="width: 50px; height: 18px;"></div></td>
            <!-- Biofuel -->
            <td><div class="skeleton-cell skeleton" style="width: 50px; height: 18px;"></div></td>
            <!-- Distance -->
            <td><div class="skeleton-cell skeleton" style="width: 70px; height: 18px;"></div></td>
            <!-- Req CII -->
            <td><div class="skeleton-cell skeleton" style="width: 55px; height: 18px;"></div></td>
            <!-- Ref CII -->
            <td><div class="skeleton-cell skeleton" style="width: 55px; height: 18px;"></div></td>
            <!-- Attained CII -->
            <td><div class="skeleton-cell skeleton" style="width: 55px; height: 18px;"></div></td>
            <!-- Rating -->
            <td class="text-center">
              <div class="skeleton-cell skeleton" style="width: 32px; height: 22px; border-radius: 12px; margin: 0 auto;"></div>
            </td>
            <!-- Allowance -->
            <td class="text-center">
              <div class="skeleton-cell skeleton" style="width: 24px; height: 24px; border-radius: 50%; margin: 0 auto;"></div>
            </td>
            <!-- Generate Report -->
            <td class="text-center" *ngIf="subusername !== 'demo'">
              <div class="skeleton-cell skeleton" style="width: 24px; height: 24px; border-radius: 50%; margin: 0 auto;"></div>
            </td>
          </tr>
        </ng-container>
        <!-- Actual Data -->
        <ng-template #dataRows>
          <tr *ngFor="let element of paginatedData; let i = index">

            <td>{{ i + 1 }}</td>

            <!-- BDN -->
            <td class="th-text-center" *ngIf="username === 'Meraki - Operations'">
              <button mat-icon-button color="primary" matTooltip="Open BDN Details" (click)="openInsideTable(element)">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </td>

            <!-- Upload BDN/LOP -->
            <td class="th-text-center" *ngIf="username === 'Meraki - Operations'">
              <button mat-icon-button color="accent" matTooltip="Upload BDN / LOP" (click)="openFetchBdnPopup(element)">
                <mat-icon>cloud_upload</mat-icon>
              </button>
            </td>

            <td> <button class="gradient-btn" (click)="showDetails(element)"
                [ngStyle]="{ 'background-image': 'linear-gradient(98deg,#0046de,#006063)', 'border-radius': '11px', border: 'none' }">
                <mat-icon fontSet="material-icons-outlined" fontIcon="visibility" class="visiblityIcon">
                  visibility_outlined </mat-icon> </button> </td>

            <!-- Vessel Info -->
            <td class="left">
              <span [ngClass]="{
                'cii-a-text': element.rating === 'A',
                'cii-b-text': element.rating === 'B',
                'cii-c-text': element.rating === 'C',
                'cii-d-text': element.rating === 'D',
                'cii-e-text': element.rating === 'E'
              }">
                {{ element.ship_name || '-' }}
              </span>
            </td>
            <td class="left">{{ element.imo_number || '-' }}</td>
            <td class="left">{{ element.type_of_vessel || '-' }}</td>
            <td class="left">{{ element.vessel_ice_class || 'No' }}</td>
            <td class="left">{{ +element.loadline_summer_deadweight_metric_tonnes ? (element.loadline_summer_deadweight_metric_tonnes | number:'1.0-0') : '-' }}</td>

            <!-- Fuel -->
            <td>{{ +element.fuel_consumed_hfo ? (element.fuel_consumed_hfo | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.fuel_consumed_lfo ? (element.fuel_consumed_lfo | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.fuel_consumed_mdo ? (element.fuel_consumed_mdo | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.fuel_consumed_lng ? (element.fuel_consumed_lng | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.fuel_consumed_biogas ? (element.fuel_consumed_biogas | number:'1.2-2') : '-' }}</td>

            <!-- CII -->
            <td>{{ +element.distance_travelled ? (element.distance_travelled | number:'1.0-0') : '-' }}</td>
            <td>{{ element.required_cii || '-' }}</td>
            <td>{{ element.referenced_cii || '-' }}</td>
            <td>{{ element.attained_cii || '-' }}</td>

            <!-- Rating -->
            <td [ngClass]="{
                'cii-a': element.rating === 'A',
                'cii-b': element.rating === 'B',
                'cii-c': element.rating === 'C',
                'cii-d': element.rating === 'D',
                'cii-e': element.rating === 'E'
              }">
              {{ element.rating || '-' }}
            </td>

            <!-- Generate Report -->
            <td class="text-center">
              <button mat-icon-button 
                      class="allowance-action-btn"
                      [disabled]="isImoLoading(element)"
                      (click)="openAllowanceForVessel(element)"
                      matTooltip="View 3-Month Predictive CII Allowance & Margin">
                <mat-icon *ngIf="!isImoLoading(element)" 
                          style="font-size: 20px; color: #38bdf8;">speed</mat-icon>
                <mat-spinner *ngIf="isImoLoading(element)" 
                             class="btn-spinner"
                             diameter="20" 
                             strokeWidth="2.5" 
                             color="accent"></mat-spinner>
              </button>
            </td>
            <td class="text-center" *ngIf="subusername !== 'demo'">
              <mat-icon matTooltip="Generate IMO CII Report" (click)="openGenerateReportPopup(element)"
                style="cursor:pointer; font-size:22px">
                description
              </mat-icon>
            </td>

          </tr>
          <!-- No Data State -->
          <tr *ngIf="paginatedData.length === 0">
            <td [attr.colspan]="username === 'Meraki - Operations' ? 20 : 18" class="text-center"
              style="padding: 20px;">
              No data available for the selected filters.
            </td>
          </tr>
        </ng-template>
      </tbody>


    </table>
  </div>





  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons>
  </mat-paginator>

  <!-- <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div> -->

</div>

<br />